import { Factory, association, trait } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  desk: association(),

  bookingSource: faker.lorem.slug(3),
  cancelled: false,
  userEmail: faker.internet.email(),
  locationId: 1,
  userId: 1,

  asUserDefined: trait({
    deskAvailability: 'userAssigned',
  }),
});
